export const home0bj0ne = {
  id: "events",
  lightBg: true,
  lightText: false,
  lightTextDesc: false,
  topline: "Premium Information",
  headLine: "What is Cryptocurrency?",
  description:
    "A cryptocurrency is a form of digital asset based on a network that is distributed across a large number of computers. This decentralized structure allows them to exist outside the control of governments and central authorities.",
  buttonLabel: "Learn more",
  imgStart: true,
  img: require("../../images/svg-1.svg"),
  alt: "crypto",
  dark: false,
  primary: false,
  darkText: true,
};

export const home0bjTwo = {
  id: "about",
  lightBg: false,
  lightText: true,
  lightTextDesc: true,
  topline: "Premium information",
  headLine: "What is Live Stats?",
  description:
    " Live Stats is part of the Real Time Statistics Project team of developers, researchers, and analysts with the goal of making statistics available in a dynamic and time relevant format to a wide audience around the world.",
  buttonLabel: "Get started",
  imgStart: true,
  img: require("../../images/svg-2.svg"),
  alt: "btc",
  dark: true,
  primary: true,
  darkText: false,
};

export const home0bjThree = {
  id: "contact",
  lightBg: true,
  lightText: false,
  lightTextDesc: false,
  topline: "Premium NFT",
  headLine: "What is NFT?",
  description:
    "A non-fungible token is a unique and non-interchangeable unit of data stored on a digital ledger. NFTs can be used to represent easily-reproducible items such as photos, videos, audio, and other types of digital files as unique items, and use blockchain technology to establish a verified and public proof of ownership.",
  buttonLabel: "Get started",
  imgStart: true,
  img: require("../../images/svg-3.svg"),
  alt: "nft",
  dark: false,
  primary: false,
  darkText: true,
};
